import React, { useEffect, useState, Fragment,useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DivLayout from "components/sales/divLayout/divLayout";
import ModalPop from 'components/sales/modal/modal';
import Images from "assets/images/imageData";
import { Link } from 'react-router-dom';
import ListFilters from "components/sales/ListFilters/ListFilters";

//   const applyFilter = async (filterData) => {
//     console.log(filterData);
//     setIsLoading(true);
//     // setFilterData(filterData);
//     // await getApprovedSaleListing(filterData, 1);
//     setIsLoading(false);
//     filterToggle();
//   };


const PerformanceTracker = ({
    getBlockedData,
    updateUserStatus,
    blockedUserData=[],
    updateBlockedUser={}
}) => {
      const [isLoading, setIsLoading] = useState(false);
      const [pageCount, setPageCount] = useState(0);
      const [filterData, setFilterData] = useState(null);
      const [showFilter, setShowFilter] = useState(false);
      const [isStatusSuccess, setIsStatusSuccess] = useState(false);
      const [listData, setListData] = useState();
        const [isSuccessModel, setIsSuccessModel] = useState(false);
        const [isModal, setIsModal] = useState(false);

        const handleSuccessModalHide = () => setIsSuccessModel(false);
        const handleModalHide = () => setIsModal(false);

    const filterToggle = () => {
        setShowFilter(!showFilter);
      };
    
    useEffect(() => {
        (async () => {
        await getBlockedData();
        })();
    }, []);

    const headerBtns = () => {
        return (
          <Fragment>
             <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent"
            >
              {localization.showFilters}
            </Button> 
          </Fragment>
        );
      };
    //   const onPageChange = async (val) => {
    //     let filter = filterData === null ? null : filterData;
    //     setIsLoading(true);
    //     await getBlockedData(filter, val.selected + 1);
    //     setIsLoading(false);
    //   };
      const unblockUser = async (id) => {
        // let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        const res=await updateUserStatus(id);
        // const res=false
        if(res==true){
            setIsSuccessModel(true);
            await getBlockedData();
        }else{
            setIsModal(true);
        }
        setIsLoading(false);
      };
      const applyFilter = async (filterData) => {
        setIsLoading(true);
        setFilterData(filterData);
        console.log("FILTER",filterData);
        await getBlockedData(filterData);
        setIsLoading(false);
        filterToggle();
      };
  return (
    <Layout
          title={localization.executivesPerformanceTracker}
          Buttons={headerBtns}
          isLoading={isLoading}
        >
        <h4>
            {`Executives Blocked Today | ${blockedUserData.today_date}`}
        </h4>
        <div className="container my-4">
  {blockedUserData &&
    blockedUserData.block_user_data &&
    blockedUserData.block_user_data.length > 0 &&
    blockedUserData.block_user_data.map((user) => (
      <div key={user.user_id} className="panel-card mb-4 border rounded">
        <div className="panel-body p-3">
          {/* User Details */}
          <div className="details-listing mb-3">
            <div className="row mb-3">
              <div className="col-sm-4">
                <DivLayout heading="Executive" data={user.user_name} />
              </div>
              <div className="col-sm-4">
                <DivLayout
                  heading={`No. of Blocks (Last ${filterData?.days_filter || "7"} Days)`}
                  data={user.blocks_last_7_days}
                />
              </div>
              <div className="col-sm-4">
                <DivLayout
                  heading={`No. of Meetings (Last ${filterData?.days_filter || "7"} Days)`}
                  data={user.meetings_last_7_days}
                />
              </div>
            </div>
          </div>

          {/* Last 3 Meetings Table */}
          {user.last_3_meetings && user.last_3_meetings.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr style={{backgroundColor:'#c5eaf7'}}>
                    <th>Meeting #</th>
                    <th>Client Name</th>
                    <th>MOM</th>
                    <th>Activity Date</th>
                  </tr>
                </thead>
                <tbody>
                  {user.last_3_meetings.map((meeting, index) => {
                    let meetingLabel;
                    switch (index) {
                      case 0:
                        meetingLabel = "Last Meeting";
                        break;
                      case 1:
                        meetingLabel = "2nd Last Meeting";
                        break;
                      case 2:
                        meetingLabel = "3rd Last Meeting";
                        break;
                      default:
                        meetingLabel = `Meeting ${index + 1}`;
                    }
                    return (
                      <tr key={index}>
                        <td>{meetingLabel}</td>
                        <td>{meeting.site_name}</td>
                        <td>
                          <textarea
                            className="form-control"
                            style={{
                              width: '100%',
                              height: '107px',
                              resize: 'none',
                              overflowY: 'scroll',
                            }}
                            value={meeting.mom}
                            readOnly
                          />
                        </td>
                        <td>{meeting.activity_date}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No meetings available.</p>
          )}

          {/* Update User Button */}
          <div className="d-flex" style={{justifyContent: 'flex-end'}}>
          {user.status === 0 ? (
            <button
              className="btn btn-sm"
              style={{backgroundColor: 'green', color: 'white'}} 
              onClick={() => unblockUser(user.user_id)}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#62a562'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'green'}

            >
              Unblock User
            </button>
          ) : (
           
    
              <strong style={{ color: 'green'}}>Unblocked</strong>
          )}
          </div>
        </div>
      </div>
    ))}
</div>
          <h4>
            {localization.executivesTrackRecord}
          </h4>
          <div className="d-flex justify-content-center">
          <table className="table table-bordered w-100" border="1" style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}
            border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{backgroundColor:'#c5eaf7'}}>
            <th>Executive</th>
            <th>No. of Blocks in last {filterData?.days_filter || "7"} days</th>
            <th>No. of Blocks in last {filterData?.days_filter || "7"} days</th>
          </tr>
        </thead>
        <tbody>
          {blockedUserData !== {} && blockedUserData.user_data && blockedUserData.user_data.length>0 && blockedUserData.user_data.map((user, index) => (
            <tr key={index}>
              <td>{user.name}</td>
              <td>{user.block_counts}</td>
              <td>{user.meeting_counts}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        performanceFilter
        />
      <ModalPop
        title={localization.updatedSuccessfully}
        show={isSuccessModel}
        handleModalHide={handleSuccessModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.success}</h5>
          <Link to="#" onClick={handleSuccessModalHide} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.updatedSuccessfully}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.ErrorImg} alt="" style={{"height": "inherit"}}/>
          </div>
          <h5>{localization.oppsWrong}</h5>
          <Link to="#" onClick={handleModalHide} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
        </Layout>
  )
}

export default PerformanceTracker